import { render, staticRenderFns } from "./purview.vue?vue&type=template&id=3834ad2d&scoped=true"
import script from "./purview.vue?vue&type=script&lang=js"
export * from "./purview.vue?vue&type=script&lang=js"
import style0 from "./purview.vue?vue&type=style&index=0&id=3834ad2d&prod&lang=scss"
import style1 from "./purview.vue?vue&type=style&index=1&id=3834ad2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834ad2d",
  null
  
)

export default component.exports